import Image from 'utils/image';
import formatMoney from 'utils/format-money';

export default (product) => {
  const strings = window.theme.strings.product;

  const getImages = () => (product.images.length ? `${Image(product.images[0])}${Image(product.images.length > 1 ? product.images[1] : product.images[0])}` : '');

  const getPlussizeLabel = () => (product.plussize ? `<div class="product-item__plussize">${strings.labels.plussize}</div>` : '');

  const getLabels = () => {
    const labels = [];

    if (product.compareAtPrice > product.price) {
      const difference = product.compareAtPrice - product.price;
      const savingPercentage = `${Math.floor((difference / product.compareAtPrice) * 100)}%`;
      labels.push(savingPercentage);
    }

    const publishedSeconds = new Date(product.publishedAt).getTime();
    const nowSeconds = new Date().getTime();
    const differenceSeconds = nowSeconds - publishedSeconds;
    const differenceDays = differenceSeconds / 3600 / 24;

    if (differenceDays < window.theme.config.productNewLimit) {
      labels.push(strings.labels.new);
    }

    product.tags.filter((tag) => tag.includes('Label_')).forEach((tag) => labels.push(tag.replace('Label_', '')));

    if (labels.length) {
      return `<div class="product-item__labels">
        ${labels.map((label) => `<div class="product-item__labels__item">${label}</div>`).join('')}
      </div>`;
    }
    return '';
  };

  const getPrice = () => formatMoney(product.price, theme.moneyFormat);

  const getCompareAtPrice = () => (product.compareAtPrice ? formatMoney(product.compareAtPrice, theme.moneyFormat) : '');

  const getSizes = () => {
    const sizes = product.options.find((option) => option.name.toLowerCase() === 'size')?.values;

    if (sizes?.length) {
      return `<div class="product-item__sizes">
        <ul class="product-item__sizes__list">
          ${sizes.map((size) => `<li class="product-item__sizes__item">${size}</li>`).join('')}
        </ul>
      </div>`;
    }

    return '';
  };

  const getColors = () => {
    let colors = product.options.find((option) => option.name.toLowerCase() === 'color')?.values.map((value) => value.toLowerCase()); // eslint-disable-line
    return colors ? colors.map((color) => `"${color}"`).join(',') : '';
  };

  return window.theme.templates.productItem
    .replaceAll('%url%', product.url)
    .replace('%images%', getImages())
    .replace('%plussize%', getPlussizeLabel())
    .replace('%labels%', getLabels())
    .replace('%title%', product.title)
    .replace('%price%', getPrice())
    .replace('%compareAtPrice%', getCompareAtPrice())
    .replace('%sizes%', getSizes())
    .replace('%colors%', getColors());
};
